import { produce } from "immer";
import { GlobalActions, resetAction } from "../../globals/store/actions";
import { InstagramLoginSetting } from "../interface/api/instagram-login-api";
import {
  getInstagramLoginFailureAction,
  getInstagramLoginInitAction,
  getInstagramLoginSuccessAction,
  getInstagramLoginUrlFailureAction,
  getInstagramLoginUrlInitAction,
  getInstagramLoginUrlSuccessAction,
  InstagramLoginApiAction,
  postBindInstagramLoginFailureAction,
  postBindInstagramLoginInitAction,
  postBindInstagramLoginSuccessAction,
  postUnbindInstagramLoginFailureAction,
  postUnbindInstagramLoginInitAction,
  postUnbindInstagramLoginSuccessAction,
} from "./api-actions";

export interface InstagramLoginState {
  settings: InstagramLoginSetting | null;
  loginUrl: string;
  error: string;
}

const initialState: InstagramLoginState = {
  settings: null,
  loginUrl: "",
  error: "",
};

export default produce(
  (
    draft: InstagramLoginState = initialState,
    action: InstagramLoginApiAction | GlobalActions
  ) => {
    switch (action.type) {
      case postBindInstagramLoginSuccessAction.type:
      case getInstagramLoginSuccessAction.type:
        draft.settings = action.settings;
        draft.error = "";
        return draft;
      case postUnbindInstagramLoginSuccessAction.type:
        draft.settings = null;
        return draft;
      case postBindInstagramLoginFailureAction.type:
      case getInstagramLoginFailureAction.type:
      case postUnbindInstagramLoginFailureAction.type:
      case getInstagramLoginUrlFailureAction.type:
        draft.error = action.error;
        return draft;
      case getInstagramLoginUrlSuccessAction.type:
        draft.loginUrl = action.url;
        return draft;
      case getInstagramLoginUrlInitAction.type:
        draft.loginUrl = "";
        return draft;
      case getInstagramLoginInitAction.type:
        draft.error = "";
        return draft;
      case resetAction.type:
        return initialState;
      case postBindInstagramLoginInitAction.type:
      case postUnbindInstagramLoginInitAction.type:
      default:
        return draft;
    }
  }
);
